import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const links = [
  { href: "#problem", label: "Problem" },
  { href: "#device", label: "Device" },
  { href: "#run", label: "The Run" },
  { href: "#vision", label: "Vision" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-black/60 backdrop-blur-2xl"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2"
        >
          <span className="relative inline-flex h-2 w-2">
            <span className="pulse-dot absolute inline-flex h-full w-full rounded-full bg-[#ff5500]" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#ff5500]" />
          </span>
          <span className="font-display text-xl font-semibold tracking-tighter">
            ARVEX
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="link-underline font-mono text-xs uppercase tracking-[0.22em] text-white/70 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#waitlist"
            data-testid="nav-cta-waitlist"
            className="btn-primary hidden rounded-full px-5 py-2 font-mono text-xs uppercase tracking-[0.18em] md:inline-flex"
          >
            Join Waitlist
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/15 md:hidden"
            aria-label="Open menu"
          >
            <div className="flex flex-col gap-1">
              <span className="h-px w-4 bg-white" />
              <span className="h-px w-4 bg-white" />
            </div>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="border-t border-white/10 bg-black/90 backdrop-blur-2xl md:hidden"
            data-testid="nav-mobile-menu"
          >
            <div className="flex flex-col gap-2 px-6 py-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-2 font-mono text-xs uppercase tracking-[0.22em] text-white/80"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#waitlist"
                onClick={() => setOpen(false)}
                className="btn-primary mt-3 rounded-full px-5 py-3 text-center font-mono text-xs uppercase tracking-[0.18em]"
              >
                Join Waitlist
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
